// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2z50N","col":"CardReaderDesc_col__N-Hxt","label":"CardReaderDesc_label__3A1Lp"};